import React, {useState} from "react";
import "../MainPage.css";

export const InformationCardComponent = ({ cards = [] }) => {
    const [isContentVisible, setIsContentVisible] = useState(false);
    const toggleContent = () => setIsContentVisible(!isContentVisible);

    return (
        <section className="information-card">
            <nav className={"information-card-nav"}>
                <h3>Перевірте свою готовність!</h3>
                <p>Для заповнення анкети без перерв і помилок переконайтеся, що ви відповідаєте усім ключовим вимогам та маєте наявні всі необхідні електронні документи</p>
            </nav>
            <nav className={"information-card-nav card-nav-button"}>
                <svg
                    className={`information-card-nav-button ${isContentVisible ? 'rotated' : ''}`}
                     onClick={toggleContent}
                     viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 10L12.0008 14.58L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </nav>
            <div className={`information-card-container ${isContentVisible ? 'visible' : 'hidden'}`}>
                {cards.length > 0 && cards.map((card, index) => (
                    <React.Fragment key={index}>
                        <div className="information-card-container-main">
                            <nav className="information-card-container-nav">
                                <img
                                    src={card.imageSrc1}
                                    alt={card.imageAlt1}
                                    className="icons-information-card"
                                />
                                <p>{card.title1}</p>
                            </nav>
                            <ul className="information-card-container-ul">
                                {card.items1?.map((item, itemIndex) => (
                                    <li key={itemIndex} className="information-card-container-li">
                                        <img
                                            src={item.imageSrc}
                                            alt={item.imageAlt}
                                            className="icons-item-information-card"
                                        />
                                        <span>{item.text}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="information-card-container-main">
                            <nav className="information-card-container-nav">
                                <img
                                    src={card.imageSrc2}
                                    alt={card.imageAlt2}
                                    className="icons-information-card"
                                />
                                <p>{card.title2}</p>
                            </nav>
                            <ul className="information-card-container-ul">
                                {card.items2?.map((item, itemIndex) => (
                                    <li key={itemIndex} className="information-card-container-li">
                                        <div className="information-card-container-group">
                                            <strong>{item.title}</strong>
                                            <ul className="information-card-container-sublist">
                                                {item.li?.map((li, liIndex) => (
                                                    <li key={liIndex}>{li.text}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
};